import React from "react";

import { IgDialog } from "@intelligems/ig-theme/IgDialog";
import { IgTextField } from "@intelligems/ig-theme/IgTextField";

interface ForcePasswordResetViewProps {
  password: string;
  minLength: number;
  isSubmitting: boolean;
  errorMessage: string | null;
  onPasswordChange: (value: string) => void;
  onSubmit: () => void;
  onLogout: () => void;
}

export const ForcePasswordResetView = ({
  password,
  minLength,
  isSubmitting,
  errorMessage,
  onPasswordChange,
  onSubmit,
  onLogout,
}: ForcePasswordResetViewProps) => {
  const tooShort = password.length < minLength;

  return (
    <IgDialog
      showDialog
      disableEscapeKeyDown
      shouldNotClose
      handleClose={() => undefined}
      title="Set a new password"
      subtitle="For security, you must choose a new password before continuing."
      rawContent={
        <IgTextField
          autoFocus
          fullWidth
          type="password"
          label="New password"
          autoComplete="new-password"
          value={password}
          onChange={(event) => onPasswordChange(event.currentTarget.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !tooShort && !isSubmitting) {
              onSubmit();
            }
          }}
          error={!!errorMessage}
          helperText={
            errorMessage ?? `Must be at least ${minLength} characters.`
          }
        />
      }
      yesButtonText="Set new password"
      yesButtonDisabled={tooShort || isSubmitting}
      handleYesClick={onSubmit}
      loading={isSubmitting}
      noButtonText="Log out"
      handleNoClick={onLogout}
    />
  );
};
